<template>
  <div>
    <div class="menu-w color-scheme-light color-style-transparent menu-position-side menu-side-left menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link">
       <div class="logo-w">
         <router-link class="logo" to="/">
           <img v-bind:src="require('../../assets/img/onetap_transparent.png')"></img>
           <div class="logo-label">zero1</div>
         </router-link>
       </div>
       <div class="logged-user-w avatar-inline" v-if="this.$root.isAuthenticated">
          <div class="logged-user-i">
            <div class="avatar-w">
              <img alt="" :src="this.$root.userProfile.avatar">
            </div>
             <div class="logged-user-info-w">
                <div class="logged-user-name">{{ this.$root.userProfile.username }}</div>
                <div class="logged-user-role">Rank: {{ this.$root.userProfile.rank.name }}</div>
             </div>
          </div>
       </div>
       <ul class="main-menu">
         <li>
           <router-link to="/">
             <div class="icon-w">
               <div class="far fa-home"></div>
             </div>
             <span>Home</span>
           </router-link>
         </li>
         <li>
           <a href="https://wa.me/62811148308">
             <div class="icon-w">
               <div class="far fa-phone-volume"></div>
             </div>
             <span><b>WhatsApp Support</b></span>
           </a>
         </li>
         <li class="sub-header">
           <span>Account</span>
         </li>
         <li v-if="!this.$root.isAuthenticated">
           <a href="https://api.onetap.co.id/auth/steam">
             <div class="icon-w">
               <div class="far fa-sign-in-alt"></div>
             </div>
             <span><b>Login with Steam</b></span>
           </a>
         </li>
         <li v-if="this.$root.isAuthenticated">
           <a href="#" @click="$root.logout()">
             <div class="icon-w">
               <div class="far fa-sign-out-alt"></div>
             </div>
             <span>Logout</span>
           </a>
         </li>
         <li class="sub-header">
           <span>zero1</span>
         </li>
         <li>
           <router-link to="/tnc">
             <div class="icon-w">
               <div class="far fa-paperclip"></div>
             </div>
             <span>T&C / Privacy Policy</span>
           </router-link>
         </li>
         <li>
           <router-link to="/servers">
             <div class="icon-w">
               <div class="far fa-server"></div>
             </div>
             <span>Servers</span>
           </router-link>
         </li>
         <li>
           <router-link to="/premium">
             <div class="icon-w">
               <div class="far fa-tags"></div>
             </div>
             <span>Premium</span>
           </router-link>
         </li>
         <li>
           <router-link to="/statistics">
             <div class="icon-w">
               <div class="far fa-bomb"></div>
             </div>
             <span>Statistics</span>
           </router-link>
         </li>
         <li class="sub-header">
           <span>zero1 League</span>
         </li>
         <li>
           <router-link to="/league">
             <div class="icon-w">
               <div class="far fa-bomb"></div>
             </div>
             <span>Season 1 Statistics</span>
           </router-link>
         </li>
         <br>
       </ul>
       <div class="side-menu-magic">
         <h4>
           Questions/Help
         </h4>
         <p>
           Email: hello@zero1.id<br>or<br>WhatsApp us!
         </p>
       </div>
     </br></br></br></br></br></br></br></br></br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {
      //
    }
  },
  computed: {

  },
  methods: {
    getChannels() {
      this.axios.get(`${this.API_URL}/users/channels`).then((res) => {
        this.channels = res.data
      })
    },
    getGlobalChannels() {
      this.axios.get(`${this.API_URL}/channels`).then((res) => {
        this.channels = res.data
      })
    },
    fetchChannels() {
      if (this.$root.isAuthenticated) {
        this.getChannels()
      } else {
        this.getGlobalChannels()
      }
    },
    getHuman(timestamp) {
      return window.moment(timestamp).fromNow()
    }
  },
  created() {
    //
  },
  watch: {
    //
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
